<template>
  <v-row class="project-slider">
    <v-col cols="12" class="align-baseline">
      <div v-if="Project.fetched && !projects.length">
        <v-card-title class="py-0 title font-weight-bold letter-spacing-normal">
          No projects available. Please
          <router-link class="px-2" to="/projects/create">
            create one
          </router-link>
          to proceed.
        </v-card-title>
      </div>
      <v-carousel
        v-else
        height="240"
        :show-arrows="false"
        light
        v-model="index"
        class="elevation-4 c-carousel--dotted"
        delimiter-icon=""
      >
        <v-carousel-item v-for="(project, i) in projects" :key="i">
          <v-card tile class="pa-0 " height="240">
            <v-container class="pa-0 fill-height">
              <v-row
                justify="space-between"
                class="flex-column-reverse flex-md-row flex-md-row-reverse fill-height pa-0 ma-0"
              >
                <v-col class="py-0 px-0">
                  <v-img
                    :src="getMedia(project)"
                    lazy-src="/placeholder.jpg"
                    aspect-ratio="1.7"
                    class="fill-height"
                  />
                </v-col>
                <v-col>
                  <v-card-title
                    class="px-5 pt-2 pt-md-8 pb-0 pb-md-2 font-weight-bold title"
                  >
                    {{ project.name }}
                  </v-card-title>

                  <div
                    class="pt-2 px-5 pb-md-5"
                    v-html="project.description.excerpt(100, '...')"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-carousel-item>
      </v-carousel>
    </v-col>
  </v-row>
</template>

<style>
.project-slider {
  padding-bottom: 35px;
}
.v-btn--icon.v-size--small {
  height: 16px;
  width: 16px;
}
</style>

<script>
import Project from '@models/Project';

export default {
  name: 'CustomTripProjectSlider',
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      project_id: this.value,
      index: 0,
      requiresUpdate: true,
      syncedWithIndex: false,
      syncedWithProjectID: false,
      projects: [],
      Project: new Project({
        itemsPerPage: 5,
        filters: {
          graduated: false,
        },
      }),
    };
  },
  watch: {
    async project_id(projectID) {
      this.requiresUpdate = false;
      this.$emit('input', projectID);
      if (this.syncedWithIndex) {
        this.syncedWithIndex = false;
        return;
      }
      this.syncIndex(true);
    },
    value(value) {
      if (!this.requiresUpdate) {
        this.requiresUpdate = true;
        return;
      }
      this.project_id = value;
    },
    index() {
      if (this.syncedWithProjectID) {
        this.syncedWithProjectID = false;
        return;
      }
      this.syncIndex();
    },
  },
  methods: {
    async fetchProjects() {
      let isfetchinFirstTime = !this.Project.fetched;
      let response = await this.Project.getLeastContributed();
      if (response) {
        this.projects = response.data;
        if (isfetchinFirstTime && this.projects.length) {
          if (!this.project_id) {
            this.project_id = this.projects[0].id;
          }
        }
      }
    },
    syncIndex(syncWithProject = false) {
      let projectID = this.project_id;
      let index = this.index;
      if (syncWithProject) {
        this.syncedWithProjectID = true;
        this.index = this.projects.findIndex(
          (project) => project.id === projectID
        );
      } else {
        this.syncedWithIndex = true;
        this.project_id = this.projects[index].id;
      }
    },
  },
  mounted() {
    this.fetchProjects();
  },
};
</script>
